import React from 'react'
import styled from 'styled-components'
import NetworkTag from 'atoms/NetworkTag'
import { ConfigConsumer } from 'contexts/config-context'
import Shields from './Shields'

const Wrapper = styled.header`
  height: 54px;
  background-color: rgba(36, 59, 82, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #E2E2E2;
`

const NetworkTagWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 16px;

  svg {
    path {
      fill: #FFF !important;
    }
  }
`

const ContentWrapper = styled.div`
    width: ${props => props.width || '1280px'};
    display: flex;
    justify-content: center;
`

function NetworkNav (props) {
  return (
    <ConfigConsumer>
      {config => (
        <Wrapper>
          <ContentWrapper width={config.contentMaxWidth}>
            <NetworkTagWrapper>
              <NetworkTag />
            </NetworkTagWrapper>
            <Shields />
          </ContentWrapper>
        </Wrapper>
      )}
    </ConfigConsumer>
  )
}

export default NetworkNav



// WEBPACK FOOTER //
// ./src/organisms/Header/DesktopHeader/components/NetworkNav.js